import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React from "react";
import { DATETIME_FORMAT_FOR_DISPLAY } from "../../constants/constants";

const Content = props => {
  const {
    note,
    modifyNoteError,
    modifyNoteText,
    noteId,
    noteStatus,
    modifyNoteConfirm,
    cleanModify,
    setModifyNoteText
  } = props;

  const maxChar = 255;
  const textMaxChar = "Inserire max " + maxChar + " caratteri.";

  let errorClass = modifyNoteError ? "errorInput" : "invisible";

  return (
    <div>
      <span id={"contentText_" + note.id}>
        {" "}
        {/* {note.noteText.replace(/(?:\r\n|\r|\n)/g, <br/>)} */}
        {note.noteText
          ? note.noteText.split("\n").map((item, key) => {
            return (
              <React.Fragment key={key}>
                {item}
                <br />
              </React.Fragment>
            );
          })
          : null}
        {note.updatedOn ? (
          <span style={{ fontSize: "14px", color: "#86899d" }}>
            {" "}
            [Modificato il{" "}
            {moment(note.updatedOn).format(DATETIME_FORMAT_FOR_DISPLAY)}
            ]
          </span>
        ) : null}
      </span>
      <TextArea
        autoSize={{ minRows: 2, maxRows: 6 }}
        autoFocus
        className={errorClass}
        id={"inputText_" + note.id}
        value={modifyNoteText}
        size="large"
        placeholder={"modifica commento"}
        onChange={e => setModifyNoteText(e.target.value)}
        style={{ margin: "20px 0" }}
      />
      <div
        style={{
          marginTop: "-10px",
          marginBottom: "10px",
          color: "#D82829"
        }}
      >
        {modifyNoteError &&
        note.id === noteId
          ? modifyNoteError
          : null}
        {modifyNoteText &&
        noteId === note.id &&
        modifyNoteText.trim().length > maxChar
          ? textMaxChar
          : null}
      </div>
      {noteStatus &&
      noteStatus.started &&
      noteId === note.id ? (
          <div style={{ textAlign: "center" }}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{ fontSize: "24px", color: "#2084c2" }}
            />
          </div>
        ) : (
          <div
            id={"btns_" + note.id}
            style={{
              display:
              modifyNoteError &&
              note.id === noteId
                ? "block"
                : "none"
            }}
          >
            <Button
              style={{
                width: "calc(51% - 7px)",
                marginRight: "10px",
                verticalAlign: "middle"
              }}
              onClick={() => modifyNoteConfirm(note.id)}
            >
              {noteStatus && noteStatus.statusModify.loading ? (
                <FontAwesomeIcon
                  icon={["far", "circle-notch"]}
                  spin
                  style={{ fontSize: "18px", color: "#FFF" }}
                />
              ) : (
                "Modifica commento"
              )}
            </Button>
            <Button
              kind={"secondary"}
              colorScheme={"ghost"}
              onClick={() => cleanModify(note.id)}
              style={{ width: "calc(49% - 7px)" }}
            >
            Annulla
            </Button>
          </div>
        )}
    </div>
  );
};

export default Content;
